export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-fb6fcc173172f1388bc6a5327288b6e5.svg";